export interface CitationsTodaySummary {
    issued?: number;
    voided?: number;
}
